const base64ToBlob = (base64, mime = 'application/pdf') => {
  const byteCharacters = atob(base64);
  const byteArrays: any[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = Array.from(slice, (char) => char.charCodeAt(0));
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mime });
};

export const handleDownloadPdfFromBase64 = ({
  base64String,
  fileName,
  openPreviewFile,
}: {
  base64String: string;
  fileName?: string;
  openPreviewFile?: boolean;
}) => {
  const blob = base64ToBlob(base64String);
  const url = URL.createObjectURL(blob);
  if (openPreviewFile) {
    window.open(url);
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'file.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
